export default __webpack_public_path__ + "static/media/twitter.2cd3f83a.svg";